import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { App } from './App';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ToastProvider } from './contexts/ToastContext';
import { GoogleReviewProvider } from './contexts/GoogleReviewContext';
import { MilestoneReviewProvider } from './contexts/MilestoneReviewContext';
import { GoogleReviewTrigger } from './components/ToxicDetector/GoogleReviewTrigger';
const GlobalModals = lazy(() => import('./components/GlobalModals').then(m => ({
  default: m.GlobalModals
})));
const NotFoundPage = lazy(() => import('./pages/NotFoundPage').then(m => ({
  default: m.NotFoundPage
})));
const StaticHtmlPage = lazy(() => import('./pages/StaticHtmlPage').then(m => ({
  default: m.StaticHtmlPage
})));
import { mainRoutes } from './routes/mainRoutes';
import { protectedRoutes } from './routes/protectedRoutes';
// Known public paths that have static HTML in production but may not have explicit React routes
const PUBLIC_PREFIXES = ['/about', '/blog', '/faq', '/privacy', '/terms', '/es', '/fr', '/de', '/pt', '/ja', '/ko', '/hi', '/id'];
function CatchAllRoute() {
  const location = useLocation();
  const isPublic = PUBLIC_PREFIXES.some(prefix => location.pathname === prefix || location.pathname.startsWith(prefix + '/'));
  // For any public path not matched by explicit routes, render static HTML from /public
  if (isPublic) {
    return <StaticHtmlPage data-id="element-51" />;
  }
  return <NotFoundPage data-id="element-52" />;
}
function PageLoader() {
  return <div className="flex items-center justify-center min-h-screen bg-[#050505]" data-id="element-53">
      <div className="flex flex-col items-center gap-4" data-id="element-54">
        <div className="w-8 h-8 border-2 border-red-500 border-t-transparent rounded-full animate-spin" data-id="element-55" />
        <span className="text-gray-400 text-sm font-mono tracking-wider" data-id="element-56">
          LOADING...
        </span>
      </div>
    </div>;
}
function AuthenticatedTriggers() {
  const {
    user
  } = useAuth();
  return <GoogleReviewTrigger userId={user?.id} data-id="element-57" />;
}
export function AppRouter() {
  return <BrowserRouter data-id="element-58">
      <AuthProvider data-id="element-59">
        <ToastProvider data-id="element-60">
          <GoogleReviewProvider data-id="element-61">
            <MilestoneReviewProvider data-id="element-62">
              <AuthenticatedTriggers data-id="element-63" />
              <Suspense fallback={null} data-id="element-64">
                <GlobalModals data-id="element-65" />
              </Suspense>
              <Suspense fallback={<PageLoader data-id="element-67" />} data-id="element-66">
                <Routes data-id="element-68">
                  <Route path="/" element={<App data-id="element-70" />} data-id="element-69" />
                  {mainRoutes}
                  {protectedRoutes}
                  <Route path="*" element={<CatchAllRoute data-id="element-72" />} data-id="element-71" />
                </Routes>
              </Suspense>
            </MilestoneReviewProvider>
          </GoogleReviewProvider>
        </ToastProvider>
      </AuthProvider>
    </BrowserRouter>;
}